import * as React from 'react';

import Search16 from './Search16';

export const search16 = () => <Search16 />;

export default {
    title: 'Icon/Fill/Search16',
    component: Search16,
    parameters: {
        notes: "`import Search16 from 'box-ui-elements/es/icon/fill/Search16';`",
    },
};
